import { SystemStyleObject } from "@styled-system/css";
import { Variants } from "packages/dsaui/src/theme";

export const text: Variants["text"] = {
  caps: {
    textTransform: "uppercase",
  },
  heading: {
    fontFamily: "heading",
    fontWeight: "heading",
    lineHeight: "heading",
    mb: 3,
    mt: 2,
  },
  title: { fontFamily: "body", fontSize: 3, fontWeight: "bold" },
  lead: {
    fontFamily: "body",
    fontWeight: "bold",
    mb: 3,
    textTransform: "capitalize",
  },
  section: {
    color: "darkRed",
    fontSize: 2,
    textTransform: "capitalize",
    mb: 2,
  },
  subtitle: {
    fontWeight: "body",
    fontStyle: "italic",
    mb: 3,
  },
  error: {
    color: "red",
  },
  body: {
    fontWeight: "body",
  },
  input: {
    fontWeight: "body",
    fontSize: 0,
  },
  accordion: {
    display: "flex",
    gap: 3,
    ":hover": {
      cursor: "pointer",
      color: "red",
      transition: "color 0.2s",
    },
  },
};

const whiteLinkStyles: SystemStyleObject = {
  color: "white",
  textDecoration: "none",
  ":hover": { textDecoration: "underline" },
};

export const links: Variants["links"] = {
  plain: { color: "red" },
  red: {
    ...whiteLinkStyles,
    color: "red",
  },
  white: whiteLinkStyles,
};

const primaryButtonStyle: SystemStyleObject = {
  px: 4,
  py: 1,
  fontSize: 1,
  borderWidth: "2px",
  borderStyle: "solid",
  borderRadius: 4,
  transition: "all 0.2s",
  borderColor: "primary",
  bg: "primary",
  color: "white",
  fontWeight: "medium",
  ":hover": {
    cursor: "pointer",
    borderColor: "darkRed",
    backgroundColor: "darkRed",
  },
  ":disabled": {
    cursor: "not-allowed",
    backgroundColor: "darkGray",
    borderColor: "darkGray",
  },
};

export const alerts: Variants["alerts"] = {
  error: {
    fontWeight: "body",
    bg: "notifications.error",
    color: "white",
  },
  warning: {
    fontWeight: "body",
    bg: "notifications.warning",
    color: "white",
  },
  info: {
    fontWeight: "body",
    bg: "notifications.info",
    color: "black",
  },
  success: {
    fontWeight: "body",
    bg: "notifications.success",
    color: "white",
  },
};

export const buttons: Variants["buttons"] = {
  primary: primaryButtonStyle,
  inverted: {
    ...primaryButtonStyle,
    borderColor: "black",
    bg: "background",
    color: "black",
    "&:hover": {
      borderColor: "black",
      bg: "primary",
      color: "black",
    },
  },
};

const primaryCardStyle: SystemStyleObject = {
  width: ["80vw", null, "600px"],
  bg: "background",
  p: 4,
  m: [2, null, 4],
  borderRadius: 3,
  justifySelf: "center",
  "> h2:first-of-type": {
    textAlign: "center",
  },
};

export const cards: Variants["cards"] = {
  primary: primaryCardStyle,
};

export const forms: Variants["forms"] = {
  label: {
    fontSize: 1,
    fontWeight: "bold",
  },
  select: {
    borderColor: "midGray",
    borderRadius: 2,
    borderWidth: 2,
  },
  input: {
    borderColor: "midGray",
    borderRadius: 1,
    borderWidth: 2,
    pl: 3,
    "&:focus": {
      borderColor: "black",
      outline: "none",
    },
    "&::placeholder": {
      color: "darkGray",
    },
  },
  radio: {
    color: "black",
    "&:active": {
      color: "primary",
    },
  },
};
